import React from 'react';
import { ExternalLinkIcon } from 'lucide-react';
import type { Lang } from '../../types/funnel';
import { testimonials, reviewProfileUrl } from '../../data/testimonials';
import { BrandPhoto } from './BrandPhoto';
const copy = {
  en: {
    title: 'See the team. See the trucks.',
    titleReviews: 'See the team. See the trucks. Read what customers say.',
    sub: 'Real photos from InstaMovers Florida jobs. Locations aren’t specified.',
    crew: 'Our uniformed crew',
    truck: 'Our wrapped trucks',
    load: 'Organized, protected loads',
    readMore: 'Read more reviews'
  },
  es: {
    title: 'Conoce al equipo. Conoce los camiones.',
    titleReviews: 'Conoce al equipo. Conoce los camiones. Lee lo que dicen los clientes.',
    sub: 'Fotos reales de trabajos de InstaMovers Florida. No se indican ubicaciones.',
    crew: 'Nuestro equipo uniformado',
    truck: 'Nuestros camiones rotulados',
    load: 'Cargas ordenadas y protegidas',
    readMore: 'Leer más reseñas'
  }
};
export function TrustSection({
  lang
}: {
  lang: Lang;
}) {
  const c = copy[lang];
  const hasReviews = testimonials.length > 0;
  return <section className="border-t border-ink-200 bg-paper" data-id="element-1072" data-mp="1a2w9xqryfn5m">
      <div className="mx-auto max-w-6xl px-4 py-14 sm:px-6" data-id="element-1073" data-mp="w23aqsqpk3w6">
        <h2 className="font-display text-3xl font-black text-ink" data-id="element-1074" data-mp="w3mw2xr8154t">{hasReviews ? c.titleReviews : c.title}</h2>
        <p className="mt-2 text-ink-600" data-id="element-1075" data-mp="112hj6bw81fuq">{c.sub}</p>
        <div className="mt-8 grid gap-4 md:grid-cols-[1.4fr_1fr]" data-id="element-1076" data-mp="1orimxlu402to">
          <figure data-id="element-1077" data-mp="1sscb8gbgrjn3">
            <BrandPhoto role="crew" fallbackRoles={['fleet']} alt="Three uniformed crew members beside the moving truck" className="aspect-[4/3] w-full rounded-2xl" data-id="element-1078" data-mp="1sqrfwohbrwo6" />
            <figcaption className="mt-2 text-sm font-semibold text-ink" data-id="element-1079" data-mp="1jzipq15fbo0s">{c.crew}</figcaption>
          </figure>
          <div className="grid gap-4" data-id="element-1080" data-mp="27ojunef1sh1b">
            <figure data-id="element-1081" data-mp="27nij78u4dsj2">
              <BrandPhoto role="fleet" alt="Side view of a wrapped moving truck" className="aspect-[16/9] w-full rounded-2xl" data-id="element-1082" data-mp="27n0f5q17ua0l" />
              <figcaption className="mt-2 text-sm font-semibold text-ink" data-id="element-1083" data-mp="2mbihsx6vgpa8">{c.truck}</figcaption>
            </figure>
            <figure data-id="element-1084" data-mp="2hcfoub4629im">
              <BrandPhoto role="loading" alt="Truck interior with protected belongings in organized rows" className="aspect-[16/9] w-full rounded-2xl" data-id="element-1085" data-mp="2he0ilyinpoff" />
              <figcaption className="mt-2 text-sm font-semibold text-ink" data-id="element-1086" data-mp="27ejcxh3enajg">{c.load}</figcaption>
            </figure>
          </div>
        </div>

        {hasReviews && <ul className="mt-10 grid gap-6 md:grid-cols-3" data-id="element-1087" data-mp="23f0vivaslhld">
            {testimonials.map(r => <li key={`${r.name}-${r.date}`} className="flex flex-col border-t-2 border-ink pt-4" data-id="element-1088" data-mp="1yk4puscmuvps">
                <blockquote className="text-[15px] leading-relaxed text-ink" data-id="element-1089" data-mp="1tl0k6box3g47">“{r.quote}”</blockquote>
                <p className="mt-auto pt-4 text-sm font-semibold text-ink" data-id="element-1090" data-mp="1olxecp1455v6">{r.name}</p>
                <a href={r.sourceUrl} target="_blank" rel="noreferrer" className="text-xs text-ink-500 underline underline-offset-2" data-id="element-1091" data-mp="1jo5jpn9335na">
                  {r.source} · {new Date(r.date).toLocaleDateString(lang === 'es' ? 'es-US' : 'en-US', {
              month: 'short',
              year: 'numeric'
            })}
                </a>
              </li>)}
          </ul>}
        {hasReviews && reviewProfileUrl && <a href={reviewProfileUrl} target="_blank" rel="noreferrer" className="mt-6 inline-flex min-h-[44px] items-center gap-1.5 font-semibold text-ink underline decoration-lime decoration-2 underline-offset-4" data-id="element-1092" data-mp="46siq78lm9n3">
            {c.readMore}
            <ExternalLinkIcon className="h-4 w-4" aria-hidden="true" data-id="element-1093" data-mp="3clj94gdflmpa" />
          </a>}
      </div>
    </section>;
}